import { render, staticRenderFns } from "./StaffInfosForm.vue?vue&type=template&id=8f7feb04&scoped=true&"
import script from "./StaffInfosForm.vue?vue&type=script&lang=js&"
export * from "./StaffInfosForm.vue?vue&type=script&lang=js&"
import style0 from "./StaffInfosForm.vue?vue&type=style&index=0&id=8f7feb04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7feb04",
  null
  
)

export default component.exports